import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";

const CultureSection = styled.section`
  padding: 80px 0;
  background-color: #f8f8f8;
`;

const CultureContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
`;

const CultureItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
`;

const CultureItem = styled.div`
  background: #2640ed no-repeat;
  width: 384px;
  height: 357px;
  padding: 30px;
  border-radius: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.6s ease;
  position: relative;
  cursor: pointer;
  margin-bottom: 0;
  &:hover {
    transform: translateY(-5px);
  }
`;

const CultureItemContentWrap = styled.div`
  position: absolute;
  left: 30px;
  bottom: 30px;
  width: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;

  .culture-content {
    opacity: 0;
    height: 0;
    transition: opacity 0.3s, height 3s;
    margin: 8px 0 0 0;
    color: #fff;
  }
  .culture-line {
    width: 0;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    margin-top: 8px;
    height: 3px;
    background: #fff;
    z-index: 1;
  }

  .culture-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 0;
    text-align: left;
  }

  /* hover 效果 */
  ${CultureItem}:hover & .culture-content {
    opacity: 1;
    height: 100%;
  }
  ${CultureItem}:hover & .culture-line {
    width: 60%;
    &::before {
      position: absolute;
      bottom: -1px;
      display: block;
      content: " ";
      height: 1px;
      width: 60%;
      background: rgba(200, 200, 200, 0.6);
    }
  }
`;

import { CULTURE_CARDS } from "appLauncher";
export default function CultureSectionComponent() {
  return (
    <CultureSection>
      <CultureContainer>
        <SectionTitle>企业文化</SectionTitle>
        <SectionSubtitle>Corporate Culture</SectionSubtitle>
        <CultureItems>
          {CULTURE_CARDS.map((item, idx) => (
            <CultureItem
              key={item.title}
              style={{
                backgroundImage: "url(/assets/about/c-" + (idx + 1) + ".png)",
              }}
            >
              <CultureItemContentWrap>
                <div className="culture-title">{item.title}</div>
                <p className="culture-content">{item.content}</p>
                <div className="culture-line" />
              </CultureItemContentWrap>
            </CultureItem>
          ))}
        </CultureItems>
      </CultureContainer>
    </CultureSection>
  );
}
